import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import { Button } from "../components/ui/button";
import { PenLine, ArrowRight } from "lucide-react";

const EXAM_LABELS = { upsc: "UPSC", state_psc: "State PSC", generic: "Generic" };

export default function History() {
  const [evals, setEvals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/evaluations").then(({ data }) => setEvals(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFDF9]">
      <Navbar />
      <main className="max-w-6xl mx-auto px-5 py-10">
        <span className="text-xs uppercase tracking-[0.2em] text-[#2D6A4F] font-semibold">History</span>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight mt-2">Your evaluations</h1>
        <p className="text-[#525252] mt-1">Every copy you've had corrected, newest first.</p>

        {loading ? (
          <div className="text-[#525252] mt-8">Loading…</div>
        ) : evals.length === 0 ? (
          <div className="bg-white rounded-2xl border border-dashed border-[#D6D6CE] p-12 text-center mt-8">
            <div className="w-14 h-14 rounded-2xl bg-[#EAF1ED] flex items-center justify-center mx-auto mb-4">
              <PenLine className="w-6 h-6 text-[#2D6A4F]" />
            </div>
            <h3 className="font-semibold text-lg">Nothing here yet</h3>
            <p className="text-[#525252] mt-1 mb-5">Your evaluated answers will appear here.</p>
            <Link to="/evaluate"><Button className="rounded-full bg-[#2D6A4F] hover:bg-[#1B4332] text-white">Evaluate an answer</Button></Link>
          </div>
        ) : (
          <div className="mt-8 space-y-3">
            {evals.map((e) => (
              <Link
                key={e.id}
                to={`/result/${e.id}`}
                data-testid={`history-item-${e.id}`}
                className="group flex items-center gap-5 bg-white rounded-2xl border border-[#E5E5E5] p-5 hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow] duration-200"
              >
                <div className="w-16 text-center shrink-0">
                  {e.result ? (
                    <>
                      <div className="font-display text-3xl text-[#2D6A4F] leading-none">{e.result?.score}</div>
                      <div className="text-xs text-[#525252]">/ {e.result?.max_marks}</div>
                    </>
                  ) : (
                    <div className="text-[11px] font-semibold" style={{ color: e.status === "failed" ? "#C0492B" : "#2D6A4F" }}>
                      {e.status === "failed" ? "Failed" : "Evaluating…"}
                    </div>
                  )}
                </div>
                <div className="h-12 w-px bg-[#E5E5E5]" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-[11px] uppercase tracking-[0.15em] font-semibold text-[#2D6A4F]">{EXAM_LABELS[e.exam_type] || e.exam_type}</span>
                    {e.result?.grade && <span className="text-[11px] text-[#525252]">· {e.result.grade}</span>}
                  </div>
                  <p className="font-medium truncate">{e.question}</p>
                  <span className="text-sm text-[#525252]">{new Date(e.created_at).toLocaleString()}</span>
                </div>
                <ArrowRight className="w-5 h-5 text-[#2D6A4F] shrink-0 group-hover:translate-x-1 transition-transform" />
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
